import React from 'react';
import {connect} from 'react-redux';

import ThemeManager from '../../lib/theme-manager';
import {setFbPixelId} from '../../redux/addonReducer';
import fbPixelService from '../../lib/fbPixel-service';

class Theme extends React.Component {

	constructor(props) {
		super(props);
		this.merchantId = props.merchantId;
		this.theme = props.theme;
		this.themeManager = new ThemeManager(this.merchantId, this.theme);
	}

	componentDidMount() {
		const fbPixelId = this.themeManager.valueOrDefault(
			'add-ons', 'fb-pixel-id', null, null);
		this.props.setFbPixelId(fbPixelId);
		fbPixelService.initIfIdIsSet(fbPixelId);
	}

	render() {
		return (
			<ThemeContext.Provider value={{themeManager: this.themeManager}}>
				{React.Children.only(this.props.children)}
			</ThemeContext.Provider>)
	}
}


const mapDispatchToProps = (dispatch) => ({
	setFbPixelId: async (pixelId) => {
		await dispatch(setFbPixelId(pixelId));
	},
});


// Make sure the shape of the default value passed to
// createContext matches the shape that the consumers expect!
export const ThemeContext = React.createContext({
	themeManager: new ThemeManager('', '')
});


export default connect(
	null,
	mapDispatchToProps,
)(Theme);
